import { ITenant } from '../inventory';
import { IUserRole } from './types';

export const attachParamsToUrl = (
  url: string,
  params: { [x: string]: number | string | undefined },
) => {
  // did not use the URL object here because the url might already contain params
  const urlParams = Object.keys(params).reduce((acc, curr, index) => {
    if (!curr || !params[curr]) return acc;

    const pathSign = index === 0 && !url.includes('?') ? '?' : '&';

    return acc + `${pathSign}${curr}=${params[curr]}`;
  }, '');

  return url + urlParams;
};

export function validateURL(link: string | undefined | null) {
  if (!link) return false;
  return link.indexOf('http://') == 0 || link.indexOf('https://') == 0;
}

export const upperCaseFirstLetter = (string: string) =>
  string[0].toUpperCase() + string.slice(1);

type FilterTenantsByExistingRoleProps = {
  tenants: ITenant[];
  roles: IUserRole[];
  isOrgUser: boolean;
};

export const filterTenantsByExistingRole = ({
  tenants,
  roles,
  isOrgUser,
}: FilterTenantsByExistingRoleProps): ITenant[] =>
  isOrgUser
    ? tenants.filter(({ id }) => roles.find(({ tenantId }) => tenantId === id))
    : tenants;
